import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//components
import EventActions from '../EventActions';
import FormContent from './FormContent';
import EventSponsors from './EventSponsors';

const EventSetting: FC = () => {
	return (
		<Box>
			<FormContent />
			<EventSponsors />
			<EventActions />
		</Box>
	);
};

export default EventSetting;
